<template>
 <!--
    ********************************************************
    ****   FORMATO NUMERO 3 TABLA DE LINKS              ****
    ****   USADO EN PAGINAS COMO BOLETINES Y NOTICIAS   ****
    ********************************************************
  -->
<div id="Formato3">
 
    <table class="table table-striped table-hover table-bordered mt-4">
                  <thead class="thead-dark">
                    <tr>
                      <th></th>
                      <th class="titulo text-center" v-for="titulo in tituloSeccion.split('|')" :key="titulo.id" >{{titulo}}</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in contenidos" :key="index">
                      <th class="text-center texto">{{index+1}}</th>

                      <th class="texto" v-for="textoColumna in data.TextoDelContenido.split('|')" :key="textoColumna.index">{{textoColumna}}</th>
                      <th class="w-10 text-center vinculo texto" v-for="elemento in data.ArchivosDeContenidoMicrositios" :key="elemento.index">
                        <router-link v-if="elemento.AbrirEnVisor==false && elemento.RutaDelArchivo != null && elemento.RutaDelArchivo.includes('Micrositio')" :to="elemento.RutaDelArchivo" >{{elemento.TextoDescripcion}}</router-link>
                        <a v-if="elemento.AbrirEnVisor==false && elemento.RutaDelArchivo != null && elemento.RutaDelArchivo.includes('https')" :href="elemento.RutaDelArchivo" target="_blanck">{{elemento.TextoDescripcion}}</a>
                        <a v-else-if="elemento.AbrirEnVisor==false" v-on:click="AbrirArchivo(elemento.RutaDeArchivoCarpeta,'_self')">{{elemento.TextoDescripcion}}</a>
                        <a v-else-if="elemento.AbrirEnVisor==true" v-on:click="AbreElVisor(elemento.RutaDeArchivoCarpeta)">{{elemento.TextoDescripcion}}</a>
                       
                      </th>
                   </tr>
                  </tbody>
                  
                </table>
</div>
</template>
<script>
import comun from "@/../static/js/comun";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
    props:{
        contenidos:Array,
        tituloSeccion: String
    },
    methods: {
      AbreElVisor: function(vinculo) {
       //this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
       console.log("####vinculo#:",vinculo)
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta));


      },
      AbrirArchivo: function(vinculo,forma) {
        //comun.DescargarDocumentoPDF(vinculo)
        console.log("DESCARGA::::::::",vinculo)
        comun.DescargarDocumentoPDF(vinculo);
           // window.open(vinculo,forma);
        },
    },
}
</script>
<style  scoped>
.titulo{
  font-family: 'AntenaBeta';
  font-size: 16px;
}
#Formato3 .titulo:last-child {
    text-align: center;
  }

  .vinculo a{
color: black;
  font-family: 'Myriad';
  font-size: 1em;

  }
  .texto{
    font-family: 'Myriad';
  font-size: 1.2em;
  }
  

</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/TablaDescripcionYLink.vue